<div class="container container-narrow">
    <div class="loader-container" *ngIf="model$ | async as model">

        <h2>Subscribe to {{model.PlanName}}</h2>
        <p>You’re about to upgrade one of your buttons to the {{model.PlanName}} plan.</p>

        <h3>What you’ll get</h3>
        <ul>
            <li>Up to {{model.PlanMessagesPerMonth ?? 'unlimited'}} feedback submissions per month</li>
            <li>All submissions are stored — nothing is ever lost</li>
            <li>Upgrade, downgrade or cancel anytime</li>
        </ul>

        <form #subscribeForm="ngForm" (ngSubmit)="submit(subscribeForm)" novalidate>

            <div *ngIf="model.SiteSelectItems.length == 1">
                <p>The following buttons will be upgraded.</p>
                <p><b>{{model.SiteSelectItems[0].label}}</b></p>
            </div>

            <div *ngIf="model.SiteSelectItems.length > 1" class="mb">
                <h3>Select the button to upgrade</h3>
                <p class="mb">Only buttons that are eligible for upgrade are shown below.</p>
                <dropdown-component name="siteSelector" [(selectedValue)]="model.SiteId" [options]="model.SiteSelectItems"></dropdown-component>
            </div>

            <div *ngIf="model.HasSites && model.SiteSelectItems.length == 0" class="mb">
                All your buttons are already covered by a subscription.
            </div>

            <div *ngIf="!model.HasSites" class="mb">
                You have not yet created a button yet. Go to your dashboard to create one.
            </div>

            <div *ngIf="error$ | async as error" class="error-message-box">
                {{ error }}
            </div>

            <div class="text-right">
                <button type="submit" class="btn" *ngIf="model.CanSubscribe">
                    <i class="fa fa-credit-card"></i> Continue to payment
                </button>
                <a href="{{dashboardUrl}}" class="btn" *ngIf="!model.CanSubscribe">
                    <i class="fa fa-grip"></i> To Your Dashboard
                </a>
            </div>
        </form>

        <loader-component *ngIf="loading$ | async"></loader-component>
    </div>
</div>

